var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-menu",on:{"click":function($event){return _vm.setActiveMenu(-1)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.feather.icons['chevron-left'].toSvg())}})])}
var staticRenderFns = []

export { render, staticRenderFns }